import { motion } from "framer-motion";
import { FALLBACK_IMG } from "../data/content";

const EASE = [0.16, 1, 0.3, 1];

export const FadeUp = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 44 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ num, eyebrow, title, copy, light = false }) => (
  <div className="max-w-3xl" data-testid={`section-head-${num || eyebrow?.toLowerCase().replace(/\s+/g, "-")}`}>
    <FadeUp>
      <div className="flex items-center gap-4 mb-6">
        {num && (
          <span className="font-mono text-xs tracking-[0.3em] text-gold/70">
            {num}
          </span>
        )}
        <span className="h-px w-12 bg-gold/40" />
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-gold">
          {eyebrow}
        </span>
      </div>
    </FadeUp>
    <FadeUp delay={0.1}>
      <h2 className={`font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight ${light ? "text-forest-950" : "text-cream"}`}>
        {title}
      </h2>
    </FadeUp>
    {copy && (
      <FadeUp delay={0.2}>
        <p className={`mt-5 text-base leading-relaxed max-w-xl ${light ? "text-forest-800/70" : "text-sage"}`}>
          {copy}
        </p>
      </FadeUp>
    )}
  </div>
);

export const Img = ({ src, alt, className = "", ...rest }) => (
  <img
    src={src}
    alt={alt}
    loading="lazy"
    className={className}
    onError={(e) => {
      if (e.currentTarget.src !== FALLBACK_IMG) e.currentTarget.src = FALLBACK_IMG;
    }}
    {...rest}
  />
);

export const MaskedLine = ({ children, delay = 0, as = "span" }) => (
  <span className="block overflow-hidden pb-1">
    <motion.span
      className="block will-change-transform"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export { EASE };
